import React, { useState, useRef, useEffect, RefObject } from 'react';
import { useIntersection } from 'react-use';
import { useTranslations } from 'next-intl';
import { analytics } from '@silvertours/front-entities';
import { InfoBanner as InfoBannerType } from '@silvertours/back-domain-page';
import Close from '@engineering/icons/close';
import { Ui } from '@silvertours/front-shared';
import { Wrapper, CloseButton } from './InfoBanner.styles';

const InfoBanner = ({ closable, sticky, theme, content }: InfoBannerType) => {
  const t = useTranslations('features.navigationLegacy.infoBanner');
  const [isInfoBannerVisible, setIsInfoBannerVisible] = useState(true);

  const intersectionRef = useRef<HTMLElement | null>(null);
  const intersection = useIntersection(
    intersectionRef as RefObject<HTMLElement>,
    {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    },
  );

  useEffect(() => {
    const banner = document.getElementById('infobanner');
    const links = banner?.getElementsByTagName('a');
    if (links) {
      const linkList = [].slice.call(links);
      linkList.forEach(link => {
        const anchor = link as HTMLAnchorElement;
        const label = anchor.pathname.replace(/(^\/)|(\/$)/g, '');
        anchor.onclick = () => analytics.gtm.trackInfoBannerLinkClicked(label);
      });
    }
  }, []);

  const onClose = () => {
    setIsInfoBannerVisible(false);
    analytics.gtm.trackInfoBannerCloseClicked();
  };

  return (
    <aside id="infobanner" ref={intersectionRef}>
      {isInfoBannerVisible && (
        <Wrapper
          isIntersecting={
            sticky &&
            Boolean(intersection && intersection.intersectionRatio < 1)
          }
          className={theme}
        >
          <Ui.RichText content={content} />
          {closable && (
            <CloseButton
              icon={Close}
              onClick={onClose}
              aria-label={t('hideLabel')}
            />
          )}
        </Wrapper>
      )}
    </aside>
  );
};
export { InfoBanner };
